import { Center } from '@chakra-ui/react'
import { UserSignupRegisterForm } from '@src/components/sco/Account/UserSignupRegisterForm'
import {
  MatchingSignupNav,
  matchingSignupNavItems,
} from '@src/components/sco/Matching/Layout/MatchingSignupNav'
import { OnboardingLayout } from '@src/components/sco/Onboarding/Layout/OnboardingLayout'
import { OnboardingMainPanel } from '@src/components/sco/Onboarding/Layout/OnboardingMainPanel'
import { useCurrentUser } from '@src/hooks/useCurrentUser'
import { useRouter } from 'next/navigation'
import { useEffect, useState } from 'react'

export default function Page() {
  const { currentUser } = useCurrentUser()
  const router = useRouter()
  const [submitTrigger, setSubmitTrigger] = useState(0)

  useEffect(() => {
    if (currentUser?.isRegistered) {
      router.push('/members/matching/signup/profile')
    }
  }, [currentUser?.isRegistered])

  return (
    <OnboardingLayout
      navItems={matchingSignupNavItems}
      navPanel={<MatchingSignupNav />}
      redirectUnauthenticated={false}
      mainPanel={
        <OnboardingMainPanel hideNav={true} onNext={() => setSubmitTrigger(x => x + 1)}>
          <Center margin={'auto'} maxWidth={'container.sm'} minHeight={'80vh'} paddingY={'2em'}>
            <UserSignupRegisterForm
              returnToHref={`/members/matching/signup/profile`}
              title={"First, let's create your account!"}
            />
          </Center>
        </OnboardingMainPanel>
      }
    />
  )
}
